import { ConfigService } from '@referrals/core/services/config.service';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { APP_INITIALIZER, isDevMode } from '@angular/core';
import { OktaAuthConfigService } from '@okta/okta-angular';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';

// TODO: Consider replacing with https://www.npmjs.com/package/runtime-config-loader

export function load(
  httpBackend: HttpBackend,
  config: ConfigService,
  configService: OktaAuthConfigService
): () => Promise<boolean> {
  return (): Promise<boolean> => {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      const configBase = 'config.json';
      const envFile = 'env.json';
      const configsFolder = './assets/configs';
      const configBaseUrl = `${configsFolder}/${configBase}`;
      const envUrl = `${configsFolder}/${envFile}`;
      const configRuntimeUrl = (runtime: string) =>
        `${configsFolder}/config.${runtime}.json`;

      const http = new HttpClient(httpBackend);

      http
        .get(configBaseUrl)
        .pipe(
          switchMap((baseConfig) =>
            http.get<{ env: string }>(envUrl).pipe(
              switchMap((env: { env: string }) =>
                handleEnv(env.env)
                  ? http
                      .get(configRuntimeUrl(env.env))
                      .pipe(
                        map((envConfig) =>
                          Object.assign({}, baseConfig, envConfig)
                        )
                      )
                  : of(baseConfig)
              ),
              map((result: ConfigService) => {
                config.referralsApiUrl = result.referralsApiUrl;
                config.reCaptureKey = result.reCaptureKey;
                config.okta = result.okta;
                config.featureToggles = result.featureToggles;
                const options: OktaAuthOptions = {
                  issuer: result.okta.issuer,
                  clientId: result.okta.clientId,
                  redirectUri: result.okta.redirectUri,
                  pkce: result.okta.pkce,
                  scopes: result.okta.scopes,
                  devMode: isDevMode(),
                }
                const oktaAuth = new OktaAuth(options);
                const oktaConfig = {
                  oktaAuth,
                }
                configService.setConfig(oktaConfig);
                resolve(true);
              })
            )
          )
        )
        .subscribe();
    });
  };
}

function handleEnv(env: any): string {
  if (env === undefined) {
    throw new Error(
      'missing env value in env.json, env.json should have "env": "" or "env": "prod" defined'
    );
  } else {
    return env;
  }
}

export const ConfigInitializer = {
  provide: APP_INITIALIZER,
  useFactory: load,
  multi: true,
  deps: [HttpBackend, ConfigService, OktaAuthConfigService],
};
